$(document).ready(function(){
  $(".mv_pt_custom_info_icon, .mv_pt_custom_info_text").click(function(){
    $(".mv_pt_custom_info_text").toggle();
  });
  $(".mv_pt_accordian_header").click(function(){
    if ($(this).next().hasClass("active")){
      $(this).next().removeClass("active").slideUp(300);
      $(this).find(".mv_pa_header_minus").addClass("mv_pa_header_plus");
    }
    else {
      $(".mv_pt_accordian_body").removeClass("active").slideUp(300);
      $(".mv_pa_header_minus").addClass("mv_pa_header_plus");
      $(this).next(".mv_pt_accordian_body").addClass("active").slideDown(300);
      $(this).find(".mv_pa_header_minus").removeClass("mv_pa_header_plus");
    }
  });
});



// Bundle starts
// Ataching plus/minus with input and show/hide button/input
document.addEventListener('click', function (event) {
  const addBtn = event.target.closest('.mv_product-group__product-atc');
  const plusBtn = event.target.closest('.mv_product-group__product-qtyplus');
  const minusBtn = event.target.closest('.mv_product-group__product-qtyminus');
  const productCard = event.target.closest('.mv_product-group__product');

  if (!productCard) return;

  const buttonWrapper = productCard.querySelector('.mv_product-group__product-button');
  const qtyWrapper = productCard.querySelector('.mv_product-group__product-qtyselector');
  const qtyInput = productCard.querySelector('.mv_product-group__product-qtyinput');

  if (addBtn) {
    buttonWrapper.style.display = 'none';
    qtyWrapper.style.display = 'block';
    qtyInput.value = 1;
    return;
  }

  if (plusBtn) {
    const container = plusBtn.closest('.mv_product-group__product-qty');
    const input = container.querySelector('.mv_product-group__product-qtyinput');
    const current = parseInt(input.value || 0);
    input.value = current + 1;
    return;
  }

  if (minusBtn) {
    const container = minusBtn.closest('.mv_product-group__product-qty');
    const input = container.querySelector('.mv_product-group__product-qtyinput');
    let current = parseInt(input.value || 0);

    if (current > 0) {
      current = current - 1;
      input.value = current;
    }

    if (current === 0) {
      qtyWrapper.style.display = 'none';
      buttonWrapper.style.display = 'block';
    }

    return;
  }
});


// Operation
// document.addEventListener('DOMContentLoaded', function() {
//   let requiredQuantities = {};
  
//   function getRequiredQuantityForGroup(groupElement) {
//     const heading = groupElement.querySelector('.mv_product-group__heading');
//     if (!heading) return 0;
//     const headingText = heading.textContent.trim();
//     let match = headingText.match(/^Select\s+(\d+)/i);
//     if (match) {
//       return parseInt(match[1]) || 0;
//     }
//     match = headingText.match(/^(\d+)\s+/);
//     if (match) {
//       return parseInt(match[1]) || 0;
//     }
//     return 0;
//   }

//   function getOriginalHeadingText(groupElement) {
//     const heading = groupElement.querySelector('.mv_product-group__heading');
//     if (!heading) return '';
//     let text = heading.textContent.trim();
//     text = text.replace(/^Select\s+\d+\s*/i, '');
//     text = text.replace(/^\d+\s+/, '');
//     text = text.replace(/\s*Selected$/, '');
//     text = text.replace(/^More\s+/, '');
//     return text.trim();
//   }

//   function getGroupTotalQuantity(groupElement) {
//     const inputs = groupElement.querySelectorAll('.mv_product-group__product-qtyinput');
//     let total = 0;
//     inputs.forEach(input => {
//       total += parseInt(input.value) || 0;
//     });
//     return total;
//   }

//   function getTotalQuantityAllGroups() {
//     const groups = document.querySelectorAll('.mv_product-group');
//     let grandTotal = 0;
//     groups.forEach(group => {
//       grandTotal += getGroupTotalQuantity(group);
//     });
//     return grandTotal;
//   }

//   function getTotalRequiredAllGroups() {
//     const groups = document.querySelectorAll('.mv_product-group');
//     let grandRequired = 0;
//     groups.forEach((group, index) => {
//       grandRequired += requiredQuantities[index] || getRequiredQuantityForGroup(group);
//     });
//     return grandRequired;
//   }

//   function fixPluralization(text, quantity) {
//     if (quantity === 1) {
//       return text.replace(/s$/, '');
//     } else {
//       if (!text.endsWith('s') && text.length > 0) {
//         return text + 's';
//       }
//       return text;
//     }
//   }
  
//   function resetGroupQuantities() {
//     const groups = document.querySelectorAll('.mv_product-group');
    
//     groups.forEach(group => {
//       const inputs = group.querySelectorAll('.mv_product-group__product-qtyinput');
//       inputs.forEach(input => {
//         input.value = 0;
//       });
      
//       const qtyWrappers = group.querySelectorAll('.mv_product-group__product-qtyselector');
//       qtyWrappers.forEach(wrapper => {
//         wrapper.style.display = 'none';
//       });
      
//       const buttonWrappers = group.querySelectorAll('.mv_product-group__product-button');
//       buttonWrappers.forEach(wrapper => {
//         wrapper.style.display = 'block';
//       });
//     });
//   }
  
//   function updateMainButton() {
//     const totalSelected = getTotalQuantityAllGroups();
//     const totalRequired = getTotalRequiredAllGroups();
//     const remaining = totalRequired - totalSelected;
    
//     const resultButton = document.querySelector('.mv_product-result__button');
//     const buyButton = document.querySelector('.mv_product-buy__button');
    
//     if (totalSelected >= totalRequired && totalRequired > 0) {
//       if (resultButton) resultButton.style.display = 'none';
//       if (buyButton) buyButton.style.display = 'block';
//     } else {
//       if (resultButton) resultButton.style.display = 'block';
//       if (buyButton) buyButton.style.display = 'none';
      
//       const buttonTextElement = document.querySelector('.mv_product-result__button-js');
//       if (buttonTextElement) {
//         buttonTextElement.textContent = `SELECT ${remaining} MORE ITEMS`;
//       }
//     }
//   }
  
//   function updateBundleHeadingsOnly() {
//     const checkedVariant = document.querySelector('.mv_pt-variant__input:checked');
//     if (!checkedVariant) return;
    
//     const varQuantity = parseInt(checkedVariant.getAttribute('var-quantity')) || 0;
//     const dividedQuantity = varQuantity / 2;
//     const groups = document.querySelectorAll('.mv_product-group');
    
//     groups.forEach((group, index) => {
//       const heading = group.querySelector('.mv_product-group__heading');
//       if (!heading) return;
      
//       requiredQuantities[index] = dividedQuantity;
//       let originalText = heading.textContent.trim();
//       originalText = originalText.replace(/^Select\s+\d+\s*/i, '');
//       originalText = originalText.replace(/^\d+\s+/, '');
//       originalText = originalText.replace(/\s*Selected$/, '');
//       originalText = originalText.replace(/^More\s+/, '');
      
//       let displayText = fixPluralization(originalText, dividedQuantity);
//       heading.textContent = `Select ${dividedQuantity} ${displayText}`;
//     });
    
//     setTimeout(function() {
//       updateGroupLimits();
//       updateMainButton();
//     }, 50);
//   }
  
//   function updateBundleHeadingsWithReset() {
//     const checkedVariant = document.querySelector('.mv_pt-variant__input:checked');
//     if (!checkedVariant) return;
    
//     const varQuantity = parseInt(checkedVariant.getAttribute('var-quantity')) || 0;
//     const divide
//   function fixPluralization(text, quantity) {dQuantity = varQuantity / 2;
//     const groups = document.querySelectorAll('.mv_product-group');
    
//     groups.forEach((group, index) => {
//       const heading = group.querySelector('.mv_product-group__heading');
//       if (!heading) return;
      
//       requiredQuantities[index] = dividedQuantity;
//       let originalText = heading.textContent.trim();
//       originalText = originalText.replace(/^Select\s+\d+\s*/i, '');
//       originalText = originalText.replace(/^\d+\s+/, '');
//       originalText = originalText.replace(/\s*Selected$/, '');
//       originalText = originalText.replace(/^More\s+/, '');
      
//       let displayText = fixPluralization(originalText, dividedQuantity);
//       heading.textContent = `Select ${dividedQuantity} ${displayText}`;
//     });
    
//     resetGroupQuantities();
    
//     setTimeout(function() {
//       updateGroupLimits();
//       updateMainButton();
//     }, 50);
//   }
  
//   function updateGroupLimits() {
//     const groups = document.querySelectorAll('.mv_product-group');
    
//     groups.forEach((group, index) => {
//       const heading = group.querySelector('.mv_product-group__heading');
//       if (!heading) return;
      
//       let requiredQty = requiredQuantities[index] || getRequiredQuantityForGroup(group);
      
//       const currentTotal = getGroupTotalQuantity(group);
      
//       let originalText = heading.textContent.trim();
//       originalText = originalText.replace(/^Select\s+\d+\s*/i, '');
//       originalText = originalText.replace(/^\d+\s+/, '');
//       originalText = originalText.replace(/\s*Selected$/, '');
//       originalText = originalText.replace(/^More\s+/, '');
      
//       const remaining = requiredQty - currentTotal;
      
//       let newHeadingText = '';
      
//       if (currentTotal >= requiredQty) {
//         let displayText = fixPluralization(originalText, currentTotal);
//         newHeadingText = `${requiredQty} ${displayText} Selected`;
//       } else if (currentTotal === 0) {
//         let requiredText = fixPluralization(originalText, requiredQty);
//         newHeadingText = `Select ${requiredQty} ${requiredText}`;
//       } else {
//         let remainingText = fixPluralization(originalText, remaining);
//         newHeadingText = `Select ${remaining} More ${remainingText}`;
//       }
      
//       heading.textContent = newHeadingText;
      
//       const plusButtons = group.querySelectorAll('.mv_product-group__product-qtyplus');
//       plusButtons.forEach(plusBtn => {
//         if (currentTotal >= requiredQty && requiredQty > 0) {
//           plusBtn.disabled = true;
//           plusBtn.style.opacity = '0.5';
//           plusBtn.style.cursor = 'not-allowed';
//         } else {
//           plusBtn.disabled = false;
//           plusBtn.style.opacity = '1';
//           plusBtn.style.cursor = 'pointer';
//         }
//       });
      
//       const productCards = group.querySelectorAll('.mv_product-group__product');
//       productCards.forEach(productCard => {
//         const addBtn = productCard.querySelector('.mv_product-group__product-atc');
//         if (!addBtn) return;
        
//         const buttonWrapper = productCard.querySelector('.mv_product-group__product-button');
//         if (buttonWrapper && buttonWrapper.style.display === 'none') {
//           return;
//         }
        
//         const qtyInput = productCard.querySelector('.mv_product-group__product-qtyinput');
//         const currentProductQty = parseInt(qtyInput.value) || 0;
        
//         if (currentProductQty === 0 && currentTotal >= requiredQty && requiredQty > 0) {
//           addBtn.disabled = true;
//           addBtn.style.opacity = '0.5';
//           addBtn.style.cursor = 'not-allowed';
//           addBtn.textContent = 'Full';
//         } else {
//           addBtn.disabled = false;
//           addBtn.style.opacity = '1';
//           addBtn.style.cursor = 'pointer';
//           addBtn.textContent = 'Add';
//         }
//       });
//     });
    
//     updateMainButton();
//   }
  
//   function handleQuantityChange(event) {
//     const group = event.target.closest('.mv_product-group');
//     if (!group) return;
    
//     const input = event.target;
//     const requiredQty = getRequiredQuantityForGroup(group);
//     const currentTotal = getGroupTotalQuantity(group);
    
//     if (currentTotal > requiredQty && requiredQty > 0) {
//       const currentValue = parseInt(input.value) || 0;
//       input.value = currentValue - 1;
//     }
    
//     updateGroupLimits();
//   }
  
//   document.addEventListener('click', function(event) {
//     const addBtn = event.target.closest('.mv_product-group__product-atc');
//     if (!addBtn) return;
    
//     const productCard = addBtn.closest('.mv_product-group__product');
//     if (!productCard) return;
    
//     const group = productCard.closest('.mv_product-group');
//     const requiredQty = getRequiredQuantityForGroup(group);
//     const currentTotal = getGroupTotalQuantity(group);
//     const qtyInput = productCard.querySelector('.mv_product-group__product-qtyinput');
//     const currentProductQty = parseInt(qtyInput.value) || 0;
    
//     if (currentProductQty > 0) return;
    
//     if (currentTotal >= requiredQty && requiredQty > 0) {
//       event.preventDefault();
//       event.stopPropagation();
//       return;
//     }
//   });
  
//   document.addEventListener('click', function(event) {
//     const plusBtn = event.target.closest('.mv_product-group__product-qtyplus');
//     if (!plusBtn) return;
    
//     if (plusBtn.disabled) {
//       event.preventDefault();
//       event.stopPropagation();
//       return;
//     }
    
//     const group = plusBtn.closest('.mv_product-group');
//     if (!group) return;
    
//     const requiredQty = getRequiredQuantityForGroup(group);
//     const currentTotal = getGroupTotalQuantity(group);
    
//     if (currentTotal >= requiredQty && requiredQty > 0) {
//       event.preventDefault();
//       event.stopPropagation();
//       return;
//     }
//   });
  
//   document.addEventListener('change', function(event) {
//     if (event.target.classList.contains('mv_product-group__product-qtyinput')) {
//       handleQuantityChange(event);
//     }
//   });

//   document.addEventListener('input', function(event) {
//     if (event.target.classList.contains('mv_product-group__product-qtyinput')) {
//       handleQuantityChange(event);
//     }
//   });

//   document.addEventListener('click', function(event) {
//     if (event.target.closest('.mv_pt_variant_label') || 
//         event.target.closest('.mv_pt-variant__input')) {
//       setTimeout(updateBundleHeadingsWithReset, 300);
//     }
//   });

//   document.addEventListener('click', function(event) {
//     const addBtn = event.target.closest('.mv_product-group__product-atc');
//     if (addBtn) {
//       setTimeout(updateBundleHeadingsOnly, 200);
//     }
//   });

//   document.addEventListener('click', function(event) {
//     const qtyBtn = event.target.closest('.mv_product-group__product-qtyminus') || 
//                    event.target.closest('.mv_product-group__product-qtyplus');
//     if (qtyBtn) {
//       setTimeout(updateBundleHeadingsOnly, 100);
//     }
//   });
  
//   setTimeout(function() {
//     updateBundleHeadingsOnly();
//   }, 500);
// });
// document.addEventListener('DOMContentLoaded', function() {
//   let requiredQuantities = {};
  
//   const LANG = {
//     select: 'Vælg',
//     selected: 'Valgt',
//     more: 'Mere',
//     products: 'Produkter'
//   };
  
//   function getRequiredQuantityForGroup(groupElement) {
//     const heading = groupElement.querySelector('.mv_product-group__heading');
//     if (!heading) return 0;
//     const headingText = heading.textContent.trim();
//     let match = headingText.match(new RegExp(`^${LANG.select}\\s+(\\d+)`, 'i'));
//     if (match) {
//       return parseInt(match[1]) || 0;
//     }
//     match = headingText.match(/^(\d+)\s+/);
//     if (match) {
//       return parseInt(match[1]) || 0;
//     }
//     return 0;
//   }

//   function getOriginalHeadingText(groupElement) {
//     const heading = groupElement.querySelector('.mv_product-group__heading');
//     if (!heading) return '';
//     let text = heading.textContent.trim();
//     text = text.replace(new RegExp(`^${LANG.select}\\s+\\d+\\s*`, 'i'), '');
//     text = text.replace(/^\d+\s+/, '');
//     text = text.replace(new RegExp(`\\s*${LANG.selected}$`), '');
//     text = text.replace(new RegExp(`^${LANG.more}\\s+`, 'i'), '');
//     return text.trim();
//   }

//   function getGroupTotalQuantity(groupElement) {
//     const inputs = groupElement.querySelectorAll('.mv_product-group__product-qtyinput');
//     let total = 0;
//     inputs.forEach(input => {
//       total += parseInt(input.value) || 0;
//     });
//     return total;
//   }

//   function getTotalQuantityAllGroups() {
//     const groups = document.querySelectorAll('.mv_product-group');
//     let grandTotal = 0;
//     groups.forEach(group => {
//       grandTotal += getGroupTotalQuantity(group);
//     });
//     return grandTotal;
//   }

//   function getTotalRequiredAllGroups() {
//     const groups = document.querySelectorAll('.mv_product-group');
//     let grandRequired = 0;
//     groups.forEach((group, index) => {
//       grandRequired += requiredQuantities[index] || getRequiredQuantityForGroup(group);
//     });
//     return grandRequired;
//   }

//   function fixPluralization(text, quantity) {
//     if (quantity === 1) {
//       return text.replace(/s$/, '');
//     } else {
//       if (!text.endsWith('s') && text.length > 0) {
//         return text + 's';
//       }
//       return text;
//     }
//   }
  
//   function resetGroupQuantities() {
//     const groups = document.querySelectorAll('.mv_product-group');
    
//     groups.forEach(group => {
//       const inputs = group.querySelectorAll('.mv_product-group__product-qtyinput');
//       inputs.forEach(input => {
//         input.value = 0;
//       });
      
//       const qtyWrappers = group.querySelectorAll('.mv_product-group__product-qtyselector');
//       qtyWrappers.forEach(wrapper => {
//         wrapper.style.display = 'none';
//       });
      
//       const buttonWrappers = group.querySelectorAll('.mv_product-group__product-button');
//       buttonWrappers.forEach(wrapper => {
//         wrapper.style.display = 'block';
//       });
//     });
//   }
  
//   function updateMainButton() {
//     const totalSelected = getTotalQuantityAllGroups();
//     const totalRequired = getTotalRequiredAllGroups();
//     const remaining = totalRequired - totalSelected;
    
//     const resultButton = document.querySelector('.mv_product-result__button');
//     const buyButton = document.querySelector('.mv_product-buy__button');
    
//     if (totalSelected >= totalRequired && totalRequired > 0) {
//       if (resultButton) resultButton.style.display = 'none';
//       if (buyButton) buyButton.style.display = 'block';
//     } else {
//       if (resultButton) resultButton.style.display = 'block';
//       if (buyButton) buyButton.style.display = 'none';
      
//       const buttonTextElement = document.querySelector('.mv_product-result__button-js');
//       if (buttonTextElement) {
//         buttonTextElement.textContent = `${LANG.select} ${remaining} ${LANG.products} ${LANG.more}`;
//       }
//     }
//   }
  
//   function updateBundleHeadingsOnly() {
//     const checkedVariant = document.querySelector('.mv_pt-variant__input:checked');
//     if (!checkedVariant) return;
    
//     const varQuantity = parseInt(checkedVariant.getAttribute('var-quantity')) || 0;
//     const groups = document.querySelectorAll('.mv_product-group');
//     const totalGroups = groups.length;
    
//     if (totalGroups === 0) return;
    
//     const dividedQuantity = varQuantity / totalGroups;
    
//     groups.forEach((group, index) => {
//       const heading = group.querySelector('.mv_product-group__heading');
//       if (!heading) return;
      
//       requiredQuantities[index] = dividedQuantity;
//       let originalText = heading.textContent.trim();
//       originalText = originalText.replace(new RegExp(`^${LANG.select}\\s+\\d+\\s*`, 'i'), '');
//       originalText = originalText.replace(/^\d+\s+/, '');
//       originalText = originalText.replace(new RegExp(`\\s*${LANG.selected}$`), '');
//       originalText = originalText.replace(new RegExp(`^${LANG.more}\\s+`, 'i'), '');
      
//       let displayText = fixPluralization(originalText, dividedQuantity);
//       heading.textContent = `${LANG.select} ${dividedQuantity} ${displayText}`;
//     });
    
//     setTimeout(function() {
//       updateGroupLimits();
//       updateMainButton();
//     }, 50);
//   }
  
//   function updateBundleHeadingsWithReset() {
//     const checkedVariant = document.querySelector('.mv_pt-variant__input:checked');
//     if (!checkedVariant) return;
    
//     const varQuantity = parseInt(checkedVariant.getAttribute('var-quantity')) || 0;
//     const groups = document.querySelectorAll('.mv_product-group');
//     const totalGroups = groups.length;
    
//     if (totalGroups === 0) return;
    
//     const dividedQuantity = varQuantity / totalGroups;
    
//     groups.forEach((group, index) => {
//       const heading = group.querySelector('.mv_product-group__heading');
//       if (!heading) return;
      
//       requiredQuantities[index] = dividedQuantity;
//       let originalText = heading.textContent.trim();
//       originalText = originalText.replace(new RegExp(`^${LANG.select}\\s+\\d+\\s*`, 'i'), '');
//       originalText = originalText.replace(/^\d+\s+/, '');
//       originalText = originalText.replace(new RegExp(`\\s*${LANG.selected}$`), '');
//       originalText = originalText.replace(new RegExp(`^${LANG.more}\\s+`, 'i'), '');
      
//       let displayText = fixPluralization(originalText, dividedQuantity);
//       heading.textContent = `${LANG.select} ${dividedQuantity} ${displayText}`;
//     });
    
//     resetGroupQuantities();
    
//     setTimeout(function() {
//       updateGroupLimits();
//       updateMainButton();
//     }, 50);
//   }
  
//   function updateGroupLimits() {
//     const groups = document.querySelectorAll('.mv_product-group');
    
//     groups.forEach((group, index) => {
//       const heading = group.querySelector('.mv_product-group__heading');
//       if (!heading) return;
      
//       let requiredQty = requiredQuantities[index] || getRequiredQuantityForGroup(group);
//       const currentTotal = getGroupTotalQuantity(group);
      
//       let originalText = heading.textContent.trim();
//       originalText = originalText.replace(new RegExp(`^${LANG.select}\\s+\\d+\\s*`, 'i'), '');
//       originalText = originalText.replace(/^\d+\s+/, '');
//       originalText = originalText.replace(new RegExp(`\\s*${LANG.selected}$`), '');
//       originalText = originalText.replace(new RegExp(`^${LANG.more}\\s+`, 'i'), '');
      
//       const remaining = requiredQty - currentTotal;
      
//       let newHeadingText = '';
      
//       if (currentTotal >= requiredQty) {
//         let displayText = fixPluralization(originalText, currentTotal);
//         newHeadingText = `${requiredQty} ${displayText} ${LANG.selected}`;
//       } else if (currentTotal === 0) {
//         let requiredText = fixPluralization(originalText, requiredQty);
//         newHeadingText = `${LANG.select} ${requiredQty} ${requiredText}`;
//       } else {
//         let remainingText = fixPluralization(originalText, remaining);
//         newHeadingText = `${LANG.select} ${remaining} ${LANG.more} ${remainingText}`;
//       }
      
//       heading.textContent = newHeadingText;
      
//       const plusButtons = group.querySelectorAll('.mv_product-group__product-qtyplus');
//       plusButtons.forEach(plusBtn => {
//         if (currentTotal >= requiredQty && requiredQty > 0) {
//           plusBtn.disabled = true;
//           plusBtn.style.opacity = '0.5';
//           plusBtn.style.cursor = 'not-allowed';
//         } else {
//           plusBtn.disabled = false;
//           plusBtn.style.opacity = '1';
//           plusBtn.style.cursor = 'pointer';
//         }
//       });
      
//       const productCards = group.querySelectorAll('.mv_product-group__product');
//       productCards.forEach(productCard => {
//         const addBtn = productCard.querySelector('.mv_product-group__product-atc');
//         if (!addBtn) return;
        
//         const buttonWrapper = productCard.querySelector('.mv_product-group__product-button');
//         if (buttonWrapper && buttonWrapper.style.display === 'none') {
//           return;
//         }
        
//         const qtyInput = productCard.querySelector('.mv_product-group__product-qtyinput');
//         const currentProductQty = parseInt(qtyInput.value) || 0;
        
//         if (currentProductQty === 0 && currentTotal >= requiredQty && requiredQty > 0) {
//           addBtn.disabled = true;
//           addBtn.style.opacity = '0.5';
//           addBtn.style.cursor = 'not-allowed';
//           addBtn.textContent = 'Fuldt';
//         } else {
//           addBtn.disabled = false;
//           addBtn.style.opacity = '1';
//           addBtn.style.cursor = 'pointer';
//           addBtn.textContent = 'Tilføj';
//         }
//       });
//     });
    
//     updateMainButton();
//   }
  
//   function handleQuantityChange(event) {
//     const group = event.target.closest('.mv_product-group');
//     if (!group) return;
    
//     const input = event.target;
//     const requiredQty = getRequiredQuantityForGroup(group);
//     const currentTotal = getGroupTotalQuantity(group);
    
//     if (currentTotal > requiredQty && requiredQty > 0) {
//       const currentValue = parseInt(input.value) || 0;
//       input.value = currentValue - 1;
//     }
    
//     updateGroupLimits();
//   }
  
//   document.addEventListener('click', function(event) {
//     const addBtn = event.target.closest('.mv_product-group__product-atc');
//     if (!addBtn) return;
    
//     const productCard = addBtn.closest('.mv_product-group__product');
//     if (!productCard) return;
    
//     const group = productCard.closest('.mv_product-group');
//     const requiredQty = getRequiredQuantityForGroup(group);
//     const currentTotal = getGroupTotalQuantity(group);
//     const qtyInput = productCard.querySelector('.mv_product-group__product-qtyinput');
//     const currentProductQty = parseInt(qtyInput.value) || 0;
    
//     if (currentProductQty > 0) return;
    
//     if (currentTotal >= requiredQty && requiredQty > 0) {
//       event.preventDefault();
//       event.stopPropagation();
//       return;
//     }
//   });
  
//   document.addEventListener('click', function(event) {
//     const plusBtn = event.target.closest('.mv_product-group__product-qtyplus');
//     if (!plusBtn) return;
    
//     if (plusBtn.disabled) {
//       event.preventDefault();
//       event.stopPropagation();
//       return;
//     }
    
//     const group = plusBtn.closest('.mv_product-group');
//     if (!group) return;
    
//     const requiredQty = getRequiredQuantityForGroup(group);
//     const currentTotal = getGroupTotalQuantity(group);
    
//     if (currentTotal >= requiredQty && requiredQty > 0) {
//       event.preventDefault();
//       event.stopPropagation();
//       return;
//     }
//   });
  
//   document.addEventListener('change', function(event) {
//     if (event.target.classList.contains('mv_product-group__product-qtyinput')) {
//       handleQuantityChange(event);
//     }
//   });

//   document.addEventListener('input', function(event) {
//     if (event.target.classList.contains('mv_product-group__product-qtyinput')) {
//       handleQuantityChange(event);
//     }
//   });

//   document.addEventListener('click', function(event) {
//     if (event.target.closest('.mv_pt_variant_label') || 
//         event.target.closest('.mv_pt-variant__input')) {
//       setTimeout(updateBundleHeadingsWithReset, 300);
//     }
//   });

//   document.addEventListener('click', function(event) {
//     const addBtn = event.target.closest('.mv_product-group__product-atc');
//     if (addBtn) {
//       setTimeout(updateBundleHeadingsOnly, 200);
//     }
//   });

//   document.addEventListener('click', function(event) {
//     const qtyBtn = event.target.closest('.mv_product-group__product-qtyminus') || 
//                    event.target.closest('.mv_product-group__product-qtyplus');
//     if (qtyBtn) {
//       setTimeout(updateBundleHeadingsOnly, 100);
//     }
//   });
  
//   setTimeout(function() {
//     updateBundleHeadingsOnly();
//   }, 500);
// });
document.addEventListener('DOMContentLoaded', function() {
  const bundlesContainer = document.querySelector('.mv_product-groups');
  if (!bundlesContainer) return;

  const LANG = {
    select: 'Vælg',
    selected: 'Valgt',
    more: 'Mere',
    products: 'Produkter'
  };

  let requiredQuantities = {};

  function getRequiredQuantityForGroup(groupElement) {
    const heading = groupElement.querySelector('.mv_product-group__heading');
    if (!heading) return 0;
    const headingText = heading.textContent.trim();
    let match = headingText.match(new RegExp(`^${LANG.select}\\s+(\\d+)`, 'i'));
    if (match) {
      return parseInt(match[1]) || 0;
    }
    match = headingText.match(/^(\d+)\s+/);
    if (match) {
      return parseInt(match[1]) || 0;
    }
    return 0;
  }

  function getOriginalHeadingText(groupElement) {
    const heading = groupElement.querySelector('.mv_product-group__heading');
    if (!heading) return '';
    let text = heading.textContent.trim();
    text = text.replace(new RegExp(`^${LANG.select}\\s+\\d+\\s*`, 'i'), '');
    text = text.replace(/^\d+\s+/, '');
    text = text.replace(new RegExp(`\\s*${LANG.selected}$`), '');
    text = text.replace(new RegExp(`^${LANG.more}\\s+`, 'i'), '');
    return text.trim();
  }

  function getGroupTotalQuantity(groupElement) {
    const inputs = groupElement.querySelectorAll('.mv_product-group__product-qtyinput');
    let total = 0;
    inputs.forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  }

  function getTotalQuantityAllGroups() {
    const groups = document.querySelectorAll('.mv_product-group');
    let grandTotal = 0;
    groups.forEach(group => {
      grandTotal += getGroupTotalQuantity(group);
    });
    return grandTotal;
  }

  function getTotalRequiredAllGroups() {
    const groups = document.querySelectorAll('.mv_product-group');
    let grandRequired = 0;
    groups.forEach((group, index) => {
      grandRequired += requiredQuantities[index] || getRequiredQuantityForGroup(group);
    });
    return grandRequired;
  }

  function fixPluralization(text, quantity) {
    if (quantity === 1) {
      return text.replace(/s$/, '');
    } else {
      if (!text.endsWith('s') && text.length > 0) {
        return text + 's';
      }
      return text;
    }
  }

  function resetGroupQuantities() {
    const groups = document.querySelectorAll('.mv_product-group');
    groups.forEach(group => {
      const inputs = group.querySelectorAll('.mv_product-group__product-qtyinput');
      inputs.forEach(input => {
        input.value = 0;
      });
      const qtyWrappers = group.querySelectorAll('.mv_product-group__product-qtyselector');
      qtyWrappers.forEach(wrapper => {
        wrapper.style.display = 'none';
      });
      const buttonWrappers = group.querySelectorAll('.mv_product-group__product-button');
      buttonWrappers.forEach(wrapper => {
        wrapper.style.display = 'block';
      });
    });
  }

  function updateMainButton() {
    const totalSelected = getTotalQuantityAllGroups();
    const totalRequired = getTotalRequiredAllGroups();
    const remaining = totalRequired - totalSelected;

    const resultButton = document.querySelector('.mv_product-result__button');
    const buyButton = document.querySelector('.mv_product-buy__button');

    if (totalSelected >= totalRequired && totalRequired > 0) {
      if (resultButton) resultButton.style.display = 'none';
      if (buyButton) buyButton.style.display = 'block';
    } else {
      if (resultButton) resultButton.style.display = 'block';
      if (buyButton) buyButton.style.display = 'none';
      const buttonTextElement = document.querySelector('.mv_product-result__button-js');
      if (buttonTextElement) {
        buttonTextElement.textContent = `${LANG.select} ${remaining} ${LANG.products} ${LANG.more}`;
      }
    }
  }

  function updateBundleHeadingsOnly() {
    const checkedVariant = document.querySelector('.mv_pt-variant__input:checked');
    if (!checkedVariant) return;

    const varQuantity = parseInt(checkedVariant.getAttribute('var-quantity')) || 0;
    const groups = document.querySelectorAll('.mv_product-group');
    const totalGroups = groups.length;
    if (totalGroups === 0) return;

    const dividedQuantity = varQuantity / totalGroups;

    groups.forEach((group, index) => {
      const heading = group.querySelector('.mv_product-group__heading');
      if (!heading) return;

      requiredQuantities[index] = dividedQuantity;
      let originalText = heading.textContent.trim();
      originalText = originalText.replace(new RegExp(`^${LANG.select}\\s+\\d+\\s*`, 'i'), '');
      originalText = originalText.replace(/^\d+\s+/, '');
      originalText = originalText.replace(new RegExp(`\\s*${LANG.selected}$`), '');
      originalText = originalText.replace(new RegExp(`^${LANG.more}\\s+`, 'i'), '');

      let displayText = fixPluralization(originalText, dividedQuantity);
      heading.textContent = `${LANG.select} ${dividedQuantity} ${displayText}`;
    });

    setTimeout(function() {
      updateGroupLimits();
      updateMainButton();
    }, 50);
  }

  function updateBundleHeadingsWithReset() {
    const checkedVariant = document.querySelector('.mv_pt-variant__input:checked');
    if (!checkedVariant) return;

    const varQuantity = parseInt(checkedVariant.getAttribute('var-quantity')) || 0;
    const groups = document.querySelectorAll('.mv_product-group');
    const totalGroups = groups.length;
    if (totalGroups === 0) return;

    const dividedQuantity = varQuantity / totalGroups;

    groups.forEach((group, index) => {
      const heading = group.querySelector('.mv_product-group__heading');
      if (!heading) return;

      requiredQuantities[index] = dividedQuantity;
      let originalText = heading.textContent.trim();
      originalText = originalText.replace(new RegExp(`^${LANG.select}\\s+\\d+\\s*`, 'i'), '');
      originalText = originalText.replace(/^\d+\s+/, '');
      originalText = originalText.replace(new RegExp(`\\s*${LANG.selected}$`), '');
      originalText = originalText.replace(new RegExp(`^${LANG.more}\\s+`, 'i'), '');

      let displayText = fixPluralization(originalText, dividedQuantity);
      heading.textContent = `${LANG.select} ${dividedQuantity} ${displayText}`;
    });

    resetGroupQuantities();

    setTimeout(function() {
      updateGroupLimits();
      updateMainButton();
    }, 50);
  }

  function updateGroupLimits() {
    const groups = document.querySelectorAll('.mv_product-group');

    groups.forEach((group, index) => {
      const heading = group.querySelector('.mv_product-group__heading');
      if (!heading) return;

      let requiredQty = requiredQuantities[index] || getRequiredQuantityForGroup(group);
      const currentTotal = getGroupTotalQuantity(group);

      let originalText = heading.textContent.trim();
      originalText = originalText.replace(new RegExp(`^${LANG.select}\\s+\\d+\\s*`, 'i'), '');
      originalText = originalText.replace(/^\d+\s+/, '');
      originalText = originalText.replace(new RegExp(`\\s*${LANG.selected}$`), '');
      originalText = originalText.replace(new RegExp(`^${LANG.more}\\s+`, 'i'), '');

      const remaining = requiredQty - currentTotal;

      let newHeadingText = '';

      if (currentTotal >= requiredQty) {
        let displayText = fixPluralization(originalText, currentTotal);
        newHeadingText = `${requiredQty} ${displayText} ${LANG.selected}`;
      } else if (currentTotal === 0) {
        let requiredText = fixPluralization(originalText, requiredQty);
        newHeadingText = `${LANG.select} ${requiredQty} ${requiredText}`;
      } else {
        let remainingText = fixPluralization(originalText, remaining);
        newHeadingText = `${LANG.select} ${remaining} ${LANG.more} ${remainingText}`;
      }

      heading.textContent = newHeadingText;

      const plusButtons = group.querySelectorAll('.mv_product-group__product-qtyplus');
      plusButtons.forEach(plusBtn => {
        if (currentTotal >= requiredQty && requiredQty > 0) {
          plusBtn.disabled = true;
          plusBtn.style.opacity = '0.5';
          plusBtn.style.cursor = 'not-allowed';
        } else {
          plusBtn.disabled = false;
          plusBtn.style.opacity = '1';
          plusBtn.style.cursor = 'pointer';
        }
      });

      const productCards = group.querySelectorAll('.mv_product-group__product');
      productCards.forEach(productCard => {
        const addBtn = productCard.querySelector('.mv_product-group__product-atc');
        if (!addBtn) return;

        const buttonWrapper = productCard.querySelector('.mv_product-group__product-button');
        if (buttonWrapper && buttonWrapper.style.display === 'none') {
          return;
        }

        const qtyInput = productCard.querySelector('.mv_product-group__product-qtyinput');
        const currentProductQty = parseInt(qtyInput.value) || 0;

        if (currentProductQty === 0 && currentTotal >= requiredQty && requiredQty > 0) {
          addBtn.disabled = true;
          addBtn.style.opacity = '0.5';
          addBtn.style.cursor = 'not-allowed';
          addBtn.textContent = 'Fuldt';
        } else {
          addBtn.disabled = false;
          addBtn.style.opacity = '1';
          addBtn.style.cursor = 'pointer';
          addBtn.textContent = 'Tilføj';
        }
      });
    });

    updateMainButton();
  }

  function handleQuantityChange(event) {
    const group = event.target.closest('.mv_product-group');
    if (!group) return;

    const input = event.target;
    const requiredQty = getRequiredQuantityForGroup(group);
    const currentTotal = getGroupTotalQuantity(group);

    if (currentTotal > requiredQty && requiredQty > 0) {
      const currentValue = parseInt(input.value) || 0;
      input.value = currentValue - 1;
    }

    updateGroupLimits();
  }

  function getSelectedGroupProducts(excludeVariantId) {
    const products = [];
    const groupProducts = document.querySelectorAll('.mv_product-group__product');
    
    groupProducts.forEach(productCard => {
      const qtyInput = productCard.querySelector('.mv_product-group__product-qtyinput');
      const quantity = parseInt(qtyInput.value) || 0;
      
      if (quantity > 0) {
        let variantId = qtyInput.getAttribute('data-variant-id');
        if (!variantId) {
          variantId = qtyInput.getAttribute('name');
        }
        
        if (variantId && parseInt(variantId) === excludeVariantId) {
          return;
        }
        
        if (!variantId || parseInt(variantId) === 0) {
          return;
        }
        
        const titleElement = productCard.querySelector('h4');
        const title = titleElement ? titleElement.textContent.trim() : 'Product';
        
        products.push({
          id: parseInt(variantId),
          quantity: quantity,
          title: title
        });
      }
    });
    
    return products;
  }

  function buildSelectionsString(products) {
    return products.map(p => `${p.title} × ${p.quantity}`).join(', ');
  }

  function setupAddToCart() {
    const addToCartBtn = document.querySelector('.product-form__submit');
    if (!addToCartBtn) return;

    const form = addToCartBtn.closest('form[action*="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      const bundlesContainer = document.querySelector('.mv_product-groups');
      if (bundlesContainer) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);

    const newBtn = addToCartBtn.cloneNode(true);
    addToCartBtn.parentNode.replaceChild(newBtn, addToCartBtn);

    let isProcessing = false;

    newBtn.addEventListener('click', async function(event) {
      const bundlesContainer = document.querySelector('.mv_product-groups');
      if (!bundlesContainer) return;

      if (isProcessing) return;
      isProcessing = true;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) {
        isProcessing = false;
        return;
      }
      const mainVariantId = parseInt(variantInput.value);
      
      const bundleSession = Date.now().toString() + Math.random().toString(36).substring(2, 8);
      
      const allSelectedProducts = getSelectedGroupProducts(mainVariantId);
      
      const groupProducts = allSelectedProducts.filter(product => {
        if (product.id === mainVariantId) {
          return false;
        }
        return true;
      });
      
      const selectionsString = groupProducts.map(p => `${p.title} × ${p.quantity}`).join(', ');
      
      const cartItems = [];
      
      const mainItem = {
        id: mainVariantId,
        quantity: 1,
        properties: {
          'Selections': selectionsString,
          '_bundle_session': bundleSession,
          '_is_bundle_main': 'true'
        }
      };
      cartItems.push(mainItem);
      
      groupProducts.forEach(product => {
        if (product.id === mainVariantId) return;
        cartItems.push({
          id: product.id,
          quantity: product.quantity,
          properties: {
            '_bundle_session': bundleSession,
            '_is_bundle_item': 'true'
          }
        });
      });
      
      const originalHTML = this.innerHTML;
      this.innerHTML = 'Tilføjer...';
      this.disabled = true;
      
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        for (const item of cart.items) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: item.line, quantity: 0 })
          });
        }
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: cartItems })
        });
        
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || 'Failed to add to cart');
        }
        
        const result = await response.json();
        
        const newCartResponse = await fetch('/cart.js');
        const newCart = await newCartResponse.json();
        const cartCount = document.querySelector('.u_nav_cart_count, .cart-count-bubble');
        if (cartCount) {
          cartCount.textContent = newCart.item_count;
        }
        
        if (typeof $ !== 'undefined') {
          $(".u_cart_drawer_block").addClass("u_cart_drawer_active");
          $("html").addClass("u_cart_overflow");
        }
        
        if (typeof updateCartDrawer === 'function') {
          setTimeout(updateCartDrawer, 500);
        }
        
        this.innerHTML = '✓ Tilføjet!';
        this.style.background = '#28a745';
        setTimeout(() => {
          this.innerHTML = originalHTML;
          this.disabled = false;
          this.style.background = '';
          isProcessing = false;
        }, 2000);
        
      } catch (error) {
        this.innerHTML = originalHTML;
        this.disabled = false;
        isProcessing = false;
      }
    });

    document.addEventListener('click', async function(event) {
      const removeBtn = event.target.closest('.u_cart_item_remove, [data-variantid]');
      if (!removeBtn) return;
      
      const variantId = removeBtn.getAttribute('data-variantid');
      if (!variantId) return;
      
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        let removedItem = null;
        let removedIndex = -1;
        
        cart.items.forEach((item, index) => {
          if (item.variant_id === parseInt(variantId)) {
            removedItem = item;
            removedIndex = index + 1;
          }
        });
        
        if (!removedItem || removedIndex === -1) {
          return;
        }
        
        const isMainBundle = removedItem.properties && removedItem.properties._is_bundle_main === 'true';
        
        if (isMainBundle) {
          const bundleSession = removedItem.properties._bundle_session;
          
          const linesToRemove = [];
          cart.items.forEach((item, index) => {
            if (item.properties && item.properties._bundle_session === bundleSession) {
              const line = index + 1;
              linesToRemove.push(line);
            }
          });
          
          linesToRemove.sort((a, b) => b - a);
          
          for (const line of linesToRemove) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: line, quantity: 0 })
            });
          }
          
          if (typeof updateCartDrawer === 'function') {
            setTimeout(updateCartDrawer, 500);
          }
          
          const newCartResponse = await fetch('/cart.js');
          const newCart = await newCartResponse.json();
          const cartCount = document.querySelector('.u_nav_cart_count, .cart-count-bubble');
          if (cartCount) {
            cartCount.textContent = newCart.item_count;
          }
        }
      } catch (error) {
        // Silent fail
      }
    });
  }

  document.addEventListener('click', function(event) {
    const addBtn = event.target.closest('.mv_product-group__product-atc');
    if (!addBtn) return;

    const productCard = addBtn.closest('.mv_product-group__product');
    if (!productCard) return;

    const group = productCard.closest('.mv_product-group');
    const requiredQty = getRequiredQuantityForGroup(group);
    const currentTotal = getGroupTotalQuantity(group);
    const qtyInput = productCard.querySelector('.mv_product-group__product-qtyinput');
    const currentProductQty = parseInt(qtyInput.value) || 0;

    if (currentProductQty > 0) return;

    if (currentTotal >= requiredQty && requiredQty > 0) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
  });

  document.addEventListener('click', function(event) {
    const plusBtn = event.target.closest('.mv_product-group__product-qtyplus');
    if (!plusBtn) return;

    if (plusBtn.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const group = plusBtn.closest('.mv_product-group');
    if (!group) return;

    const requiredQty = getRequiredQuantityForGroup(group);
    const currentTotal = getGroupTotalQuantity(group);

    if (currentTotal >= requiredQty && requiredQty > 0) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('mv_product-group__product-qtyinput')) {
      handleQuantityChange(event);
    }
  });

  document.addEventListener('input', function(event) {
    if (event.target.classList.contains('mv_product-group__product-qtyinput')) {
      handleQuantityChange(event);
    }
  });

  document.addEventListener('click', function(event) {
    if (event.target.closest('.mv_pt_variant_label') || 
        event.target.closest('.mv_pt-variant__input')) {
      setTimeout(updateBundleHeadingsWithReset, 300);
    }
  });

  document.addEventListener('click', function(event) {
    const addBtn = event.target.closest('.mv_product-group__product-atc');
    if (addBtn) {
      setTimeout(updateBundleHeadingsOnly, 200);
    }
  });

  document.addEventListener('click', function(event) {
    const qtyBtn = event.target.closest('.mv_product-group__product-qtyminus') || 
                   event.target.closest('.mv_product-group__product-qtyplus');
    if (qtyBtn) {
      setTimeout(updateBundleHeadingsOnly, 100);
    }
  });

  setTimeout(function() {
    updateBundleHeadingsOnly();
    setupAddToCart();
  }, 500);
});
// Bundle ends
